import React, { useEffect, useState } from "react";
import { Icon, Typography } from "@plum-xoxo/admin-dsm";
import styled from "styled-components";
import { Progress } from "reactstrap";
import { makeRequestAuth } from "../../../utils/globals";
import { NotificationManager } from "react-notifications";
import theme from "../../../theme";

const data = [
  {
    icon: "PlumGift",
    content: "Wide range of rewarding options.",
  },
  {
    icon: "PlumReport",
    content: "Smart tracking and management.",
  },
  {
    icon: "PlumIntegration",
    content: "Personalised rule engines and workflows.",
  },
];

const StyledIcon = styled(Icon)`
  background-color: ${(props) => props.theme.palette.light.c200};
  padding: 10px;
  border-radius: 4px;
`;

const StyledProgress = styled(Progress).attrs()`
  height: 8px;
  .progress-bar {
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
    clip-path: none;
    height: 8px;
    background-color: ${(props) => props.theme.palette.primary.c02} !important;
  }
`;
const Processing = ({ UID, countryData, email }) => {
  const [progressStatus, setProgressStatus] = useState(0);
  const [isKarmaResponseSuccess, setIsKarmaResponseSuccess] = useState(false);
  var timer = null;
  var timing = null;
  const createAccount = () => {
    const query = "diy.mutation.create_diy_plum_admin_user_v2";
    const request_data = {
      query,
      tag: "diy",
      variables: {
        diy_uuid: UID,
        currency_code: countryData?.code,
      },
    };
    makeRequestAuth(
      request_data,
      function (response) {
        if (response?.data?.createPlumDIYUserV2?.success) {
          let cid = response.data.createPlumDIYUserV2.company_id;
          startPolling(cid);
        } else {
          NotificationManager("Something went wrong");
        }
      },
      {},
      "/api/public/graph"
    );
  };

  const startPolling = (cid) => {
    let timeInitiate = Date.now();
    timing = setInterval(() => {
      if (Date.now() - timeInitiate < 15 * 60 * 1000) {
        getKarmaCompany(cid);
      } else {
        clearInterval(timing);
      }
    }, 2000);
  };

  const getKarmaCompany = (cid) => {
    const query = "diy.query.get_clientable_karma_company";
    const request_data = {
      query,
      tag: "diy",
      variables: {
        company_id: cid,
        email,
      },
    };
    makeRequestAuth(
      request_data,
      (response) => {
        if (response?.data?.getKarmaClientableCompany) {
          if (response.data.getKarmaClientableCompany.success === 1) {
            setIsKarmaResponseSuccess(true);
            clearInterval(timing);
            window.location.reload();
          }
        }
      },
      {},
      "/api/public/graph"
    );
  };

  useEffect(() => {
    timer = setInterval(() => {
      setProgressStatus((prevState) =>
        prevState <= 90 ? prevState + 1 : prevState
      );
    }, 50);
    createAccount();
    return () => {
      clearInterval(timer);
      clearInterval(timing);
    };
  }, []);

  return (
    <div className="d-flex flex-column gap-28 w-100">
      <div>
        <Typography.H1 className="mb-4">Almost there...</Typography.H1>
        <Typography>Kindly wait while we create your account.</Typography>
      </div>
      <div className="d-flex gap-20 flex-column">
        {data.map((item, index) => (
          <div key={index} className="d-flex gap-12 align-items-center">
            <StyledIcon
              iconName={item.icon}
              size={20}
              fill={theme.palette.primary.c02}
            />
            <Typography component="div" className="d-flex align-items-center">
              {item.content}
            </Typography>
          </div>
        ))}
      </div>
      <div className="d-flex gap-28 mt-8">
        <StyledProgress value={progressStatus} className={"w-100"} />
        <div>
          <Typography.BodySmall>{progressStatus}%</Typography.BodySmall>
        </div>
      </div>
    </div>
  );
};

export default Processing;
